/* global self */

import Sjcl from '@cryptolize/sjcl'
import { deriveKey } from '../core/key-derivation'
import { createRandom, createKey, createIV } from '../core/random'
import { createAsymmetricKeys, createAsymmetricKeysECDSA, signWithECDSAPrivateKey, verifyWithECDSAPublicKey } from '../core/ecc'
import { encryptText, decryptText, encryptObject, decryptObject, encryptKey, decryptKey } from '../core/aes'
import { encrypt as encryptRecord, decrypt as decryptRecord } from '../record/record'
import { decryptKeyWithSymmetricEncryption, decryptKeyWithAsymmetricEncryption } from '../record/header'
import { decrypt as decryptData } from '../record/data'
import { decrypt as decryptFile } from '../record/file'

const operations = {
  addEntropy: (ab, entropy, source) => (Sjcl.random.addEntropy(new Uint32Array(ab), entropy, source)),
  deriveKey,
  createRandom,
  createKey,
  createIV,
  createAsymmetricKeys,
  createAsymmetricKeysECDSA,
  signWithECDSAPrivateKey,
  verifyWithECDSAPublicKey,
  encryptText,
  decryptText,
  encryptObject,
  decryptObject,
  encryptKey,
  decryptKey,
  encryptRecord,
  decryptRecord,
  decryptKeyWithSymmetricEncryption,
  decryptKeyWithAsymmetricEncryption,
  decryptData,
  decryptFile
}

const toTransferables = {
  encryptRecord: (record) => record.blocks.map((block) => block.files).reduce((a, b) => a.concat(b), []).map((file) => file.data),
  decryptFile: (file) => [file]
}

self.addEventListener('message', function (e) {
  try {
    const operation = operations[e.data.operation]
    if (!operation) return self.postMessage({ id: e.data.id, result: '' })
    const result = operation.apply(null, e.data.args)
    if (toTransferables[e.data.operation]) self.postMessage({ id: e.data.id, result }, toTransferables[e.data.operation](result))
    else self.postMessage({ id: e.data.id, result }) // firefox throws error when empty array passed
  } catch (err) {
    self.postMessage({ id: e.data.id, err: err.toString() })
  }
})



// WEBPACK FOOTER //
// ./src/async/worker.js